import { Uuid } from "#customTypes/globalTypes"
import { DatabaseObject } from "#customTypes/types"

export const EVAL_COMMENT_TYPE = {
  COMMENT: "comment",
  EVENT: "event",
} as const

export type EvalCommentType =
  (typeof EVAL_COMMENT_TYPE)[keyof typeof EVAL_COMMENT_TYPE]

export const EVAL_EVENT_TYPE = {
  SUBMITTED: "submitted",
  SAVED_DRAFT: "savedDraft",
  APPROVED: "approved",
  REJECTED: "rejected",
  PRINTED: "printed",
  AUTHOR_ASSIGNED: "authorAssigned",
  APPROVER_ASSIGNED: "approverAssigned",
} as const

export type EvalEventType =
  (typeof EVAL_EVENT_TYPE)[keyof typeof EVAL_EVENT_TYPE]

export interface EvalCommentConstructor extends DatabaseObject {
  id: Uuid
  evaluationId: Uuid
  authorId: Uuid
  message: string
  type?: EvalCommentType
  eventType?: EvalEventType
}
